import { render, staticRenderFns } from "./drawerMovimenti.vue?vue&type=template&id=ddf91910"
import script from "./drawerMovimenti.vue?vue&type=script&lang=js"
export * from "./drawerMovimenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports